import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const PLAYLIST_TITLES: Record<string, string> = {
  '/paulgraham': 'Paul Graham',
  '/waitbutwhy': 'Wait But Why',
  '/gwern': 'Gwern Popular',
  '/accelerando': 'Accelerando',
};

export default function PlaylistRedirect() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const title = PLAYLIST_TITLES[pathname];

  useEffect(() => {
    if (!title) return;
    fetch(`/api/playlists/by-title/${title}`, { credentials: 'include' })
      .then((res) => res.json())
      .then((data) => {
        if (data.id) {
          navigate(`/id/${data.id}`, { replace: true });
        }
      });
  }, [title, navigate]);

  return <div className="page" />;
}
